import { render, staticRenderFns } from "./FrontpageHeaderUk.vue?vue&type=template&id=23423454&"
import script from "./FrontpageHeaderUk.vue?vue&type=script&lang=js&"
export * from "./FrontpageHeaderUk.vue?vue&type=script&lang=js&"
import style0 from "./FrontpageHeaderUk.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports